<template>
  <v-card>
    <div style="width: 100%; position: relative;">
      <h3 style="font-weight: 600; font-size: 18px; text-align: center; padding-top: 30px;">
        Cadastro abastecimento
      </h3>
      <v-btn
        icon
        style="position: absolute; right: 20px; top: 25px;"
        @click="closeModal"
      >
        <v-icon size="30">
          {{ icons.mdiClose }}
        </v-icon>
      </v-btn>
    </div>
    <div class="mt-10 mb-7 mx-7">
      <Separator label="Veículo abastecido" />
    </div>
    <v-form
      ref="form"
      class="mx-7"
    >
      <v-autocomplete
        v-model="vehicle"
        class="mt-1"
        :items="vehicleData"
        item-text="car_plate"
        item-value="car_plate"
        label="Veículo"
        :rules="[rules.required]"
        outlined
        dense
        @change="handleSelectVehicle"
      />
      <div
        v-if="!!actualCar.car_plate"
        class="mb-6"
      >
        <h3 style="font-weight: 600; font-size: 14px;">
          Detalhes do Veículo:
        </h3>
        <div
          class="mt-2 d-flex"
          style="gap: 30px;"
        >
          <div
            class="d-flex align-start"
            style="gap: 10px;"
          >
            <v-icon>{{ icons.mdiCarHatchback }}</v-icon>
            <div>
              <h3 style="font-weight: 600; font-size: 14px;">
                Modelo
              </h3>
              <span style="font-weight: 500; font-size: 13px;">
                {{ actualCar.model }}
              </span>
            </div>
          </div>
          <div
            class="d-flex align-start"
            style="gap: 10px;"
          >
            <v-icon>{{ icons.mdiTools }}</v-icon>
            <div>
              <h3 style="font-weight: 600; font-size: 14px;">
                Montadora
              </h3>
              <span style="font-weight: 500; font-size: 13px;">
                {{ actualCar.manufacturer.name }}
              </span>
            </div>
          </div>
          <div
            class="d-flex align-start"
            style="gap: 10px;"
          >
            <v-icon>{{ icons.mdiCalendarToday }}</v-icon>
            <div>
              <h3 style="font-weight: 600; font-size: 14px;">
                Ano
              </h3>
              <div class="d-flex align-center justify-center">
                <span style="font-weight: 500; font-size: 13px;">
                  {{ actualCar.manufacturing_year }}
                </span>
              </div>
            </div>
          </div>
          <div
            class="d-flex align-start"
            style="gap: 10px;"
          >
            <v-icon>{{ icons.mdiRoadVariant }}</v-icon>
            <div>
              <h3 style="font-weight: 600; font-size: 14px;">
                Km atual
              </h3>
              <div class="d-flex align-center justify-center">
                <span style="font-weight: 500; font-size: 13px;">
                  {{ actualCar.actual_km || 0 }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div
          class="d-flex flex-column"
          style="gap: 16px;"
        >
          <div class="suply-box">
            <div
              class="d-flex items-center"
              style="gap: 10px;"
            >
              <span style="font-weight: 500; font-size: 16px;">Dados do abastecimento</span>
              <v-icon>{{ icons.mdiGasStationOutline }}</v-icon>
            </div>
            <div>
              <v-autocomplete
                v-model="driverId"
                class="mt-8"
                :items="driversData"
                item-text="name"
                item-value="id"
                label="Motorista"
                :rules="[rules.required]"
                outlined
                dense
              />
              <div
                class="d-flex"
                style="gap: 16px;"
              >
                <v-text-field
                  v-model="supplyInvoice"
                  outlined
                  :rules="hasNotInvoice ? [] : [rules.required]"
                  :disabled="hasNotInvoice"
                  dense
                  label="N° da nota"
                  style="width: 50%"
                />

                <v-switch
                  v-model="hasNotInvoice"
                  dense
                  inset
                  style="margin-top: 0px; padding-top: 9px; width: 50%;"
                  label="Nota sem numeração"
                />
              </div>
              <v-autocomplete
                v-model="fuelTypeId"
                :items="listFuelType"
                item-text="name"
                item-value="id"
                label="Combustível"
                :rules="[rules.required]"
                outlined
                dense
              />
              <div
                class="d-flex"
                style="gap: 16px;"
              >
                <v-menu
                  v-model="menu1"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="supplyDateFormatted"
                      style="width: 50%"
                      label="Data"
                      :append-icon="icons.mdiCalendar"
                      :rules="[rules.required]"
                      outlined
                      dense
                      v-bind="attrs"
                      @blur="date = parseDate(supplyDateFormatted)"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="supplyDate"
                    @input="menu1 = false"
                  ></v-date-picker>
                </v-menu>
                <v-text-field
                  v-model="supplyPricePerLiter"
                  :rules="[rules.required]"
                  outlined
                  dense
                  style="width: 50%;"
                  label="Preço/L"
                  @input="handleAmountChange"
                />
              </div>
              <div
                class="d-flex"
                style="gap: 16px;"
              >
                <v-text-field
                  v-model="supplyAmountPerLiter"
                  :rules="[rules.required]"
                  outlined
                  dense
                  label="Abastecimento/L"
                  style="width: 50%"
                />
                <v-text-field
                  v-model="finalKm"
                  :rules="[rules.required]"
                  outlined
                  dense
                  style="width: 50%;"
                  label="Km final"
                />
              </div>
            </div>
          </div>

          <div class="summary-box">
            <div
              class="d-flex items-center flex-column"
              style="gap: 10px;"
            >
              <span style="font-weight: 600; font-size: 16px;">Km percorrido</span>
              <span style="text-align: center; font-weight: 500; font-size: 14px;">{{ kmPercorrido }}</span>
            </div>
            <div
              class="d-flex items-center flex-column"
              style="gap: 10px;"
            >
              <span style="font-weight: 600; font-size: 16px;">Km/L</span>
              <span style="text-align: center; font-weight: 500; font-size: 14px;">{{ kmPorLitro }}</span>
            </div>
            <div
              class="d-flex items-center flex-column"
              style="gap: 10px;"
            >
              <span style="font-weight: 600; font-size: 16px;">Valor pago</span>
              <span style="text-align: center; font-weight: 500; font-size: 14px;">{{ valorPagoFormatado }}</span>
            </div>
          </div>
        </div>
        <div
          class="d-flex align-center justify-center py-8"
          style="gap: 20px;"
        >
          <v-btn
            color="error"
            outlined
            @click="closeModal"
          >
            <span>CANCELAR</span>
          </v-btn>
          <v-btn
            color="info"
            @click="handleRegisterSupply"
          >
            <span>SALVAR</span>
          </v-btn>
        </div>
      </div>
    </v-form>
  </v-card>
</template>

<script>
import Separator from '@/components/Separator.vue'
import axiosIns from '@/plugins/axios'
import formatters from '@/plugins/formattersMixin1'
import messages from '@/plugins/showMessageMixin'
import utilsMixin from '@/plugins/utilsMixin'
import {
  mdiCalendar,
  mdiCalendarToday,
  mdiCarHatchback,
  mdiClose,
  mdiGasStationOutline,
  mdiRoadVariant, mdiTools,
} from '@mdi/js'

export default {
  name: 'RegisterFuelSuplyModal',
  components: {
    Separator,
  },
  mixins: [utilsMixin, messages, formatters],
  props: {
    vehicleData: {
      type: Array,
      default: () => [],
    },
    driversData: {
      type: Array,
      default: () => [],
    },
    listFuelType: {
      type: Array,
      default: () => [],
    },
    tripId: {
      type: [String, String],
      default: null,
    },
  },
  data() {
    return {
      icons: {
        mdiClose, mdiCalendarToday, mdiRoadVariant, mdiTools, mdiCarHatchback, mdiGasStationOutline, mdiCalendar,
      },
      vehicle: '',
      actualCar: {},
      driverId: '',
      supplyInvoice: '',
      hasNotInvoice: false,
      fuelTypeId: '',
      supplyPricePerLiter: '',
      supplyAmountPerLiter: '',
      finalKm: '',
      supplyDate: '',
      supplyDateFormatted: '',
      menu1: false,
    }
  },
  computed: {
    kmPercorrido() {
      const startKm = this.actualCar?.actual_km || 0
      const endKm = parseFloat(this.finalKm) || 0
      const diff = endKm - startKm

      return diff > 0 ? diff : 0
    },
    kmPorLitro() {
      const litros = parseFloat(this.supplyAmountPerLiter) || 0
      if (litros === 0) return 0

      return (this.kmPercorrido / litros).toFixed(2)
    },
    valorPago() {
      const litros = parseFloat(this.supplyAmountPerLiter) || 0
      const precoPorLitro = parseFloat(
        (this.supplyPricePerLiter || '').replace(/[^\d,]/g, '').replace(',', '.'),
      ) || 0

      return (litros * precoPorLitro).toFixed(2)
    },
    valorPagoFormatado() {
      return this.valorPago
        ? `R$ ${parseFloat(this.valorPago).toLocaleString('pt-BR', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`
        : 'R$ 0,00'
    },
  },
  watch: {
    supplyAmountPerLiter(val) {
      const replaced = val.replace(',', '.')
      if (replaced !== val) {
        this.supplyAmountPerLiter = replaced
      }
    },
    hasNotInvoice() {
      if (this.hasNotInvoice) {
        this.supplyInvoice = ''
      }
    },
    supplyDate() {
      this.supplyDateFormatted = this.formatDate(this.supplyDate)
    },
  },
  methods: {
    handleAmountChange(event) {
      this.supplyPricePerLiter = this.formatCurrency(event)
    },
    formatDate(date) {
      if (!date) return ''
      const [year, month, day] = date.split('-')

      return `${day}/${month}/${year}`
    },
    parseDate(date) {
      if (!date) return null

      const [day, month, year] = date.split('/')

      return `${year}-${month}-${day}`
    },
    async handleRegisterSupply() {
      const isValid = this.$refs.form.validate()
      if (!isValid) return

      if (this.kmPercorrido <= 0) {
        this.$swal({
          icon: 'warning',
          title: 'Atenção!',
          text: 'O Km percorrido deve ser maior que 0!',
          showConfirmButton: false,
          timer: 3000,
        })

        return
      }

      const body = {
        vehicle_id: this.actualCar.id,
        driver_id: this.driverId,
        invoice_number: this.supplyInvoice,
        fuel_type_id: this.fuelTypeId,
        amount_paid: this.unformatCurrency(this.valorPago),
        supply_price_per_liter: this.unformatCurrency(this.supplyPricePerLiter),
        supply_amount_per_liter: this.supplyAmountPerLiter,
        date: this.supplyDate,
        final_km: this.finalKm,
        trip_id: this.tripId ? this.tripId : null,
      }
      try {
        await axiosIns.post('/api/v1/transport/vehicles_supplies/store', body)
        this.$emit('update')
        this.$swal({
          icon: 'success',
          title: 'Sucesso!',
          text: 'As informações foram salvas!',
          showConfirmButton: false,
          timer: 3000,
        })
        this.$emit('close')
      } catch (error) {
        console.error('Erro ao registrar abastecimento:', error)
        this.$swal({
          icon: 'error',
          title: 'Erro!',
          text: 'Ocorreu um erro ao salvar informações!',
          showConfirmButton: false,
          timer: 3000,
        })
      } finally {
        this.isLoading = false
      }
    },

    handleSelectVehicle() {
      const selectedCar = this.vehicleData.find(item => item.car_plate === this.vehicle)
      this.actualCar = selectedCar
    },
  },

}
</script>

<style>
.suply-box {
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  background: #3B355A;
  min-height: 350px;
  width: 100%;
  border-radius: 10px;
  padding: 16px;
}
.summary-box {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 71px;
  background: #3B355A;
  min-height: 75px;
  width: 100%;
  border-radius: 10px;
  padding: 16px;
}
</style>
